/** Shared event-type badge label + tone for the event logs (EventLog, TabLog). */
export const EVENT_LABEL: Record<string, string> = {
  goal: "Goal",
  penalty_goal: "Pen. goal",
  own_goal: "Own goal",
  yellow_card: "Yellow",
  second_yellow: "2nd yellow",
  red_card: "Red",
  substitution: "Sub",
  var_check: "VAR",
  // PFL 3/9/10 — sync now writes these too. Left unnamed, they would show up in
  // the log as raw `penalty_missed`.
  penalty_missed: "Pen. miss",
  shootout_goal: "Shootout ✓",
  shootout_missed: "Shootout ✗",
};

export const EVENT_TONE: Record<string, string> = {
  goal: "bg-success/15 text-success border-success/35",
  penalty_goal: "bg-success/15 text-success border-success/35",
  own_goal: "bg-warning/15 text-warning border-warning/35",
  yellow_card: "bg-warning/15 text-warning border-warning/35",
  second_yellow: "bg-warning/20 text-warning border-warning/40",
  red_card: "bg-danger/15 text-danger-strong border-danger/35",
  substitution: "bg-surface-elevated text-ink-soft border-border",
  var_check: "bg-accent/15 text-accent-strong border-accent-strong/35",
  // A missed penalty — not a goal, hence "neutral-warning".
  penalty_missed: "bg-warning/10 text-warning border-warning/30",
  // The penalty shootout does not count toward the main score — unlike the goal tone, quieter.
  shootout_goal: "bg-success/10 text-success border-success/25",
  shootout_missed: "bg-danger/10 text-danger-strong border-danger/25",
};

export const eventLabel = (type: string): string => EVENT_LABEL[type] ?? type;
export const eventTone = (type: string): string =>
  EVENT_TONE[type] ?? "bg-surface-elevated text-ink-soft border-border";

const GOAL_TYPES = new Set(["goal", "penalty_goal", "own_goal"]);
const CARD_TYPES = new Set(["yellow_card", "second_yellow", "red_card"]);
/** The penalty shootout — does NOT count toward the main score (PFL document), so
 *  the score is not recalculated on delete. */
const SHOOTOUT_TYPES = new Set(["shootout_goal", "shootout_missed"]);

/** The impact line shown in the delete confirmation — along with the event, the
 *  derived state is reverted too (extension event.delete: a goal decrements the
 *  score, card counters are recalculated from the log). null for types
 *  with no such impact. */
export function deleteImpactLine(type: string): string | null {
  if (GOAL_TYPES.has(type)) return "Skor qayta hisoblanadi.";
  if (CARD_TYPES.has(type)) return "Karta hisoblagichlari qayta hisoblanadi.";
  if (SHOOTOUT_TYPES.has(type)) return "Asosiy hisobga ta'sir qilmaydi.";
  return null;
}
